<template>
  <section class="lg-dispute-message">
    <div v-if="status === 'new'" class="dispute-status">
      <hr />
      <p class="dispute-message">
        <LsIcon type="checkfull" color="primary" size="md" class="dispute-status--icon" />
        <strong>Your dispute was submitted on {{ date }}</strong>
      </p>
      <p class="dispute-details">
        Our support team will review it and get back to you with their decision asap.
      </p>
    </div>

    <div v-if="status === 'approved'" class="dispute-status">
      <hr />
      <p class="dispute-message">
        <LsIcon type="checkfull" color="primary" size="md" class="dispute-status--icon" />
        <strong> Your dispute was reviewed and accepted by our support team on {{ date }} </strong>
      </p>
      <p class="dispute-details">
        Please review your
        <RouterLink test-id="billing_view_link" :to="{ name: 'billing' }">
          billing information
        </RouterLink>
        to see the credit added to your account.
      </p>
    </div>

    <div v-if="status === 'denied'" class="dispute-status">
      <hr />
      <p class="dispute-message">
        <LsIcon type="denied" color="danger" size="md" class="dispute-status--icon" />
        <strong> Your dispute was reviewed and rejected by our support team on {{ date }} </strong>
      </p>
      <p class="dispute-details">
        You will be charged the Long Grass Fee as originally submitted by your pro. This review is
        considered final, but please reach out to
        <RouterLink test-id="support_view_link" :to="{ name: 'messageLS' }">
          {{ brandName }} support
        </RouterLink>
        with any additional questions or concerns.
      </p>
    </div>
  </section>
</template>

<script>
import moment from 'moment';
import { LsIcon } from '@/components/common';
import { themedComponentMixin } from '@/mixins';

export default {
  name: 'LgDisputeMessage',
  components: { LsIcon },
  mixins: [themedComponentMixin],
  props: {
    dispute: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    status() {
      return this.dispute.status || false;
    },
    date() {
      return moment(this.dispute.updated).format('ddd, MMM D, YYYY, h:mm a');
    },
  },
};
</script>

<style lang="scss" scoped>
.lg-dispute-message {
  padding: 0 0 3rem;

  .dispute-status {
    hr {
      background-color: $theme-color-primary-light;
      height: 0.1rem;
      margin: 0 0 3rem;
    }
    .dispute-message {
      display: flex;
      font-size: 1.4rem;
      margin-bottom: 1rem;

      .dispute-status--icon {
        flex-shrink: 0;
        margin-right: 1rem;
        width: 2.3rem;
      }
    }
    .dispute-details {
      padding-left: 3.2rem;
    }
  }
}
</style>
